export const num = (price) => parseFloat(String(price).replace(/[^\d.,]/g, "").replace(",", ".")) || 0;

export const lei = (n) => `${Math.round(n).toLocaleString("ro-RO")} lei`;

export const gross = (price, vat) => Math.round(num(price) * (1 + vat / 100));

export const resale = (price, markup, vat) => Math.round(gross(price, vat) * (1 + markup / 100));

export const shortName = (name) => name.replace("Instant Bond Repair ", "").replace(" Treatment", "");

export const isPro = (cat, id) => (cat.pro_ids || []).includes(id);

export const treatSets = (cat, items) => {
  const q = Object.fromEntries(items.map((it) => [it.id, it.qty]));
  const ids = cat.pro_ids || [];
  return ids.length ? Math.min(...ids.map((id) => q[id] || 0)) : 0;
};

export const packTotals = (pack, cat) => {
  const byId = Object.fromEntries(cat.products.map((p) => [p.id, p]));
  const sum = (list) => list.reduce((s, it) => s + gross(byId[it.id]?.price, cat.vat) * it.qty, 0);
  const list = sum(pack.items);
  const gifts = sum(pack.gifts || []);
  const price = Math.round(list * (1 - pack.discount / 100));
  const small = sum(pack.items.filter((it) => !isPro(cat, it.id)));
  const sets = treatSets(cat, pack.items);
  const treatments = sets * cat.treatments;
  const treatRevenue = treatments * cat.service_price;
  const resaleSum = Math.round((small + gifts) * (1 + cat.markup / 100));
  const revenue = resaleSum + treatRevenue;
  const count = (l) => l.reduce((s, it) => s + it.qty, 0);
  return {
    list, gifts, price, savings: list - price, resale: resaleSum, treatments, treatRevenue, revenue,
    profit: revenue - price, pieces: count(pack.items), giftPieces: count(pack.gifts || []),
  };
};
